export default {
  title: 'Commandes manquées',
  card_title: 'E-mails de commandes manquées',
  intro:
    "Si personne n'accepte une commande dans les {{minutes}} minutes, elle est refusée automatiquement. Toutes les personnes de cette liste reçoivent alors un e-mail avec la commande, afin que quelqu'un puisse assurer le suivi.",
  default: {
    owner: 'Propriétaire du restaurant',
    partner: 'Partenaire',
    owner_missing: 'Le propriétaire du restaurant ({{email}}) ne recevra pas ces e-mails.',
    partner_missing: "L'adresse par défaut du partenaire ({{email}}) ne recevra pas ces e-mails.",
  },
  empty: 'Personne ne serait informé des commandes manquées. Ajoutez au moins un e-mail pour enregistrer.',
  save_error: "Impossible d'enregistrer les e-mails. Vérifiez votre connexion et réessayez.",
  load_error: 'Impossible de charger les e-mails. Vérifiez votre connexion et réessayez.',
  unavailable: 'Les e-mails de commandes manquées ne sont pas disponibles pour ce restaurant.',
  buttons: {
    save: 'Enregistrer',
    retry: 'Réessayer',
  },
  toasts: {
    saved: 'E-mails de commandes manquées enregistrés',
  },
};
